import "lazysizes"

export default {
  init: function () {
    this.applyLazysizes()
  },

  applyLazysizes: function () {
    const lazyImages = document.querySelectorAll('.lazyload')

    if (!lazyImages) return

    document.addEventListener("lazybeforeunveil", ({target}) => {
      if (target.classList.contains("animated-icon")) {
        [...target.querySelectorAll("animate")].forEach((animate) => {
          animate.beginElement()
        })
      }
    })

    lazySizes.init()
  },
}
